import * as React from 'react';

import logger from 'js/app/loggerSingleton';

import PartnerList from 'bundles/browse-common/components/PartnerList';
import { usePartnerList } from 'bundles/browse-common/contexts/PartnerListContext';

const TopPartnersComponentRenderer = () => {
  const partnerListContext = usePartnerList();

  if (!partnerListContext) {
    logger.warn('TopPartnersComponentRenderer expected PartnerListContext');
    return null;
  }

  const { partners } = partnerListContext;

  return <PartnerList partners={partners || []} />;
};

export default TopPartnersComponentRenderer;
